import { Editor } from "@tinymce/tinymce-react";
import { useRef } from "react";


const TinyMCEEditor = () => {
  const editorRef = useRef<any>(null);

  return (
    <Editor
      apiKey="no-api-key"
      onInit={(_, editor) => (editorRef.current = editor)}
      init={{
        height: 300,
        menubar: false,
        branding: false,
        placeholder: "Type here...",
        plugins: [
          "lists",
          "link",
          "autolink",
          "code",
          "table",
          "image",
          "media",
          "anchor",
        ],

        toolbar:
          "undo redo | bold italic underline | bullist numlist | link | alignleft aligncenter alignright | code",

        content_style:
          "body { font-family: Arial, sans-serif; font-size: 14px; margin: 10px; }",
      }}
    />
  );
};


export default TinyMCEEditor;